enum NavigationCallbackType {
  NONE,
  NEXT,
  BACK,
  CURRENT,
}

export default NavigationCallbackType;
